
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './NotificationDisplay.html?raw';
import topic from 'dojo/topic';
import { NotificationTopics, NotificationTypes } from "./NotificationTypes";
import { DateHelpers, EntityHelpers, HtmlHelpers, TranslationHelpers } from "../../../more/Helpers";
import _uiFrameMixin from '../../UI/Container/uiFrame';
import _EntityViewMixin from '../../UI/EntityBased/EntityView/EntityView';
import ExpandableSection from '../../UI/Container/ExpandableSection';

/**
 * Anzeige einer einzelnen Nachricht
 */
class NotificationDisplay extends compose(_uiFrameMixin) {
    templateString: any = template;

    protected notificationID: string;
    protected notificationData: NotificationTypes.NotificationEntity_Base;

    private dateSpanContainer: HTMLElement;
    private subjectDateStartContainer: HTMLElement;
    private subjectDateEndContainer: HTMLElement;
    private notificationDateContainer: HTMLElement;
    private reminderDateContainer: HTMLElement;
    private txtDateReminder: HTMLElement;
    private txtDateNotification: HTMLElement;
    private txtDateExpiration: HTMLElement;
    private txtDateStart: HTMLElement;
    private txtDateEnd: HTMLElement;
    private txtMessage: HTMLElement;
    private txtSubject: HTMLElement;
    private iconContainer: HTMLElement;
    private entityContainer: HTMLElement;


    private _entityView: MdsLax<InstanceType<typeof _EntityViewMixin<any>>>;

    protected _callback: Function = null;

    private _onNotificationUpdated(data: NotificationTypes.NotificationEntity_Base) {
        if (this.notificationID && !data) {
            this.loadNotification();
        } else if (this.notificationID && data && this.notificationID == data.ID) {
            this.applyData(data);
        }
    }

    private loadNotification(): void {


        if (!this.notificationID) return;

        this.StandbyStart();

        let data = {
            notificationID: this.notificationID
        };

        this.RequestManager.callfunction(
            "Webtool_API_Notification__LoadNotification",
            data,
            lang.hitch(this, this._onGetNotificationDataResponse),
            lang.hitch(this, this._onGetNotificationDataError));
    }

    private _onGetNotificationDataResponse(data: NotificationTypes.NotificationEntity_Base): void {
        //console.debug("NotificationDisplay - _onGetNotificationDateResponse", data);

        
        this.applyData(data);

        this.StandbyStop();
    }

    private _onGetNotificationDataError(error: more.requestErrorMessage): void {
        console.error("NotificationDisplay - _onGetNotificationDateError", error.Message);
        this.StandbyStop();
    }

    //protected _applyData(): void {

    //}
/**
* Anzuzeigende Nachrichten-ID ändern und bei Bedarf Daten requesten.
*/
    private setId(notificationId: string) {
        let previousID = this.notificationID;
        this.notificationID = notificationId;

        
        if (previousID != notificationId) {
            if (previousID) this.removeSubscription(NotificationTopics.Updated_Single + previousID);
            if (notificationId) this.addSubscription(NotificationTopics.Updated_Single + previousID, lang.hitch(this, this._onNotificationUpdated));
        }

        if ((!this.notificationData || previousID != this.notificationData.ID) && this.notificationID) {
            this.loadNotification();
        }

    }
/**
* Nachricht (NICHT ID) zum Anzeigen hinterlegen.
* @param notificationData Nachrichten-Objekt mit ID, Inhalt, Betreff, ...
*/
/**
* @param notificationobjectOrId Nachricht oder ID der Nachricht
 * @param openInDlg Nachricht wird sofort als Dialog angezeigt; wenn false kann das Widget selber frei platziert werden oder per show-Methode.
*/
    setup(notificationobjectOrId?: string | NotificationTypes.NotificationEntity_Base, openInDlg?: boolean) {
        //console.debug("NotificationDisplay setNotification", notificationobjectOrId, typeof (notificationobjectOrId));
        
        if (typeof (notificationobjectOrId) == "string") {
            this.setId(notificationobjectOrId);
        } else if (typeof (notificationobjectOrId) == "object") {
            this.applyData(notificationobjectOrId);
        } else {
            console.warn("NotificationDisplay setNotification - falscher Datentyp?");
            return;
        }

        if (openInDlg !== false) {
            this.show("dlg", this.notificationData?.subject)
        }
    }

    protected onShow() {
        super.onShow.apply(this, arguments as any);

        if (this.notificationData) {

            this.setTitles(this.notificationData.subject, null);

            if (this.notificationData.is_confirmation_needed == true) {
                this.addButton("confirm",
                    "Notifications_Button__ConfirmNotification",
                    lang.hitch(this, this._onClick_ConfirmNotification),
                    null,
                    "primaryBG",
                    "fas fa-check",
                    false,
                    "primary",
                    this.notificationData.is_confirmed != true,
                    0
                );
            } else {
                this.removeButton("confirm");
            }

            if (this.notificationData.is_read != true) {
                setTimeout(lang.hitch(this, this._updateNotification, "read"), 3000);
            }
        }
    }

    private applyData(newData?: NotificationTypes.NotificationEntity_Base) {
        if (newData) this.notificationData = newData;

        if (!this.notificationData) return;

        this.notificationID = this.notificationData.ID;

        if (this.isActive) this.onShow();

        if (this.notificationData.iconclass) HtmlHelpers.createFontawesomeIcon(this.notificationData.iconclass, "right", this.iconContainer, "only");
        this.txtSubject.innerHTML = this.notificationData.subject;
        this.txtMessage.innerHTML = this.notificationData.message;


        this.hideNode(this.notificationDateContainer, !this.notificationData.date_notification);
        this.hideNode(this.reminderDateContainer, !this.notificationData.alert_date);
        this.hideNode(this.subjectDateStartContainer, !this.notificationData.date_subject_start);
        this.hideNode(this.subjectDateEndContainer, !this.notificationData.date_subject_end);

        this.txtDateStart.innerHTML = this.notificationData.date_subject_start ? DateHelpers.dateTimeToString(this.notificationData.date_subject_start) : "";
        this.txtDateEnd.innerHTML = this.notificationData.date_subject_end ? DateHelpers.dateTimeToString(this.notificationData.date_subject_end) : "";

        this.txtDateNotification.innerHTML = this.notificationData.date_notification ? DateHelpers.dateTimeToString(this.notificationData.date_notification) : "";
        this.txtDateReminder.innerHTML = this.notificationData.alert_date ? DateHelpers.dateTimeToString(this.notificationData.alert_date) : "";
        


        if (this.notificationData.ref_subject_entity) {

            let container = this.UiModder.domConstruct.create("div");
            

            this.addSubscription("/Entity/Opened/" + this.notificationData.ref_subject_entity.ID, lang.hitch(this, this._onOpenedEntityView, container));
            EntityHelpers.openEntityView({
                entityClass: this.notificationData.ref_subject_entity.Classname,
                entityId: this.notificationData.ref_subject_entity.ID,
                label: this.notificationData.subject,
                contextName: "notificationDisplay",
                nonInteractive: true,
                targetNode: container,
                additionalParams: {
                    notificationID: this.notificationID
                }
            });

           
        }
    }

    private _onOpenedEntityView(container: HTMLElement,  view: MdsLax<InstanceType<typeof _EntityViewMixin<any>>>) {
        this.removeSubscription("/Entity/Opened/" + this.notificationData.ref_subject_entity.ID);
        this.hideNode(this.entityContainer, false);

        let exp = new ExpandableSection();
        exp.placeAt(this.entityContainer, "only");

        exp.setup(container, view.getTitle(), "small", true, true, false);

        //view.showAtNode(view.getEntityId(), null, this.entityContainer,false);
    }
    private _onClick_ConfirmNotification() {
        this.disableButton("confirm"); // TODO: auf uiFrame disableAllButtons implementieren!!
        topic.publish(NotificationTopics.SetConfirmed, this.notificationData);
    }

    private _updateNotification(action: NotificationTypes.UpdateAction) {
        if (!this.isActive) return;

        switch (action) {
            case "read":
                topic.publish(NotificationTopics.SetRead, this.notificationID);
                break;
            case "unread":
                topic.publish(NotificationTopics.SetUnread, this.notificationID);
                break;
        }
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(NotificationDisplay);